import { useLastBreadcrumbTitle } from "@/common/helpers/breadcrumb";
import { useAppFeatureFlag } from "@/common/hooks/use-app-feature-flag";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { FeatureFlag } from "@/config/feature-flags";
import { useLocation } from "wouter";
import { CommandPalette } from "../command-palette/command-palette";
import { DeviceAware } from "../device-aware/device-aware";
import { DynamicBreadcrumb } from "../dynamic-breadcrumb/dynamic-breadcrumb";
import { UserMenu } from "./user-menu";

export function TopBar() {
  const [location] = useLocation();
  const lastBreadcrumbTitle = useLastBreadcrumbTitle(location);
  const { value: isCommandPaletteEnabled } = useAppFeatureFlag(FeatureFlag.CommandPalette);

  return (
    <header className="bg-sidebar sticky top-0 z-30 flex h-14 shrink-0 items-center">
      <div className="flex w-full items-center gap-2 px-2 md:grid md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <SidebarTrigger />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <DeviceAware
            desktopWidescreen={<DynamicBreadcrumb />}
            mobileTablet={
              lastBreadcrumbTitle ? (
                <span className="text-foreground truncate text-sm font-semibold">{lastBreadcrumbTitle}</span>
              ) : null
            }
          />
        </div>
        {isCommandPaletteEnabled && <CommandPalette />}
        <div className="flex shrink-0 items-center justify-end gap-1 sm:gap-2 md:col-start-3">
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
